import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { createMuiTheme, ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: darkMode ? "dark" : "light",
          primary: { main: "#6E2AD3" },
        },
        overrides: {
          MuiDialog: {
            paper: {
              borderRadius: 16,
            },
            paperFullScreen: {
              borderRadius: 0,
            },
          },
          MuiButton: {
            root: {
              borderRadius: 999,
              textTransform: "none",
            },
            contained: {
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            },
          },
          MuiTableCell: {
            root: {
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              verticalAlign: "middle",
              maxWidth: "none",
              padding: "6px 14px",
            },
            head: {
              textAlign: "left",
            },
            body: {
              textAlign: "left",
            },
            alignCenter: {
              textAlign: "left",
            },
          },
          MuiTable: {
            root: {
              width: "max-content",
              minWidth: "100%",
              tableLayout: "auto",
            },
          },
        },
      }),
    [darkMode]
  );

  const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useThemeContext = () => useContext(ThemeContext);
